import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

import { isFormEmpty } from '../../../../utils/is-form-empty.util';

import type { ThirdPartyForm_ThirdParty } from '../../../fragments/third-party.fragment';

export const useIsBankInfoRequired = () => {
  const { values } = useFormikContext<ThirdPartyForm_ThirdParty>();

  const [isRequired, setIsRequired] = useState(false);

  useEffect(() => {
    const isEmpty = isFormEmpty({ node: values.bankInfo });

    // TODO : check if we can refactor this code in order to respect this rule
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsRequired(!isEmpty);
  }, [values.bankInfo]);

  return { isRequired };
};
